import { render, staticRenderFns } from "./discussion-footer.vue?vue&type=template&id=158519e8&"
import script from "./discussion-footer.vue?vue&type=script&lang=js&"
export * from "./discussion-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports